import { render, staticRenderFns } from "./SubpageNav.vue?vue&type=template&id=4a558e9e&scoped=true&"
import script from "./SubpageNav.vue?vue&type=script&lang=js&"
export * from "./SubpageNav.vue?vue&type=script&lang=js&"
import style0 from "./SubpageNav.vue?vue&type=style&index=0&id=4a558e9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a558e9e",
  null
  
)

export default component.exports